import {
	useTranslationCapManage,
	useTranslationCommonUi,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Flex, Text } from '@mantine/core';
import React from 'react';
import { NamesOfPersonWithRelation, PersonRelationType } from '@dealstack/shared/lib/generated';
import { UserRowWithActions } from '@dealstack/frontend/shared/components/UserRowWithActions/UserRowWithActions.tsx';

interface Props {
	availablePeople: NamesOfPersonWithRelation[];
	relatedPeopleIds: string[] | null;
	relationType: PersonRelationType | null;
	unselectPerson: (personId: string) => void;
	hasEditPermission: boolean;
}

export const SelectedRelatedPeopleList: React.FC<Props> = ({
	availablePeople,
	relatedPeopleIds,
	relationType,
	unselectPerson,
	hasEditPermission,
}: Props) => {
	const tCapManage = useTranslationCapManage();
	const tCommonUi = useTranslationCommonUi();

	const translatedRelationType = tCommonUi(
		`person_relation_type.${relationType ?? ''}`
	).toLowerCase();

	const relatedPeople = availablePeople.filter((p) => relatedPeopleIds?.includes(p.id));

	return relatedPeople?.length ? (
		<Flex direction="column">
			<Text fw={600}>{tCapManage('related_people.title')}</Text>
			<Text c="gray.9" mt="0.25rem" mb="0.5rem">
				{tCapManage('related_people.link_message', {
					relationType: translatedRelationType,
				})}
			</Text>
			{relatedPeople.map((p) => (
				<UserRowWithActions
					key={p.id}
					displayName={p.displayName ?? ''}
					onUserDeleteClick={() => unselectPerson(p.id)}
					hasEditPermission={hasEditPermission}
				/>
			))}
		</Flex>
	) : null;
};
